export default "__VITE_ASSET__DSLUrF72__"